import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Translation Variables',
  basePath: '/translations-vars',
  columns: [
    { key: 'variable', label: 'Variable', sortable: true },
    { key: 'title', label: 'Title', sortable: true },
  ],
  fields: [
    { key: 'variable', label: 'Variable', type: 'text', required: true },
    { key: 'title', label: 'Title', type: 'text' },
  ],
  defaultSort: { field: 'variable', dir: 'asc' },
});
